import { STATUS_COLOR } from 'shared/consts';
import { getOpacityColor } from 'shared/lib/colors';
import styled, { css } from 'styled-components';

type ContainerProps = {
  $pen?: boolean
}

export const Container = styled.div<ContainerProps>`
	margin-bottom: 12px;
	margin-left: 1px;

  ${props => props.$pen && css`pointer-events: none;`}
`;

export const RadioIcon = styled.img`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  object-fit: contain;
  object-position: center;
`;

interface StatusContainerProps {
  $color: string;
  $bg?: string;
}
export const StatusContainer = styled.div<StatusContainerProps>`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  padding: 2px 4px;
  color:${STATUS_COLOR};
  border: 1px solid ${props => props.$color || '#577CF0'};
  background-color: ${props => props.$bg || getOpacityColor(props.$color, 0.4)};
  border-radius: 8px;
  line-height: 1;
  cursor: default;

  i {
    display: flex;
    justify-content:center;align-items: center;
  }
`